import { Injectable } from '@angular/core';
import {
  Router, Resolve, ActivatedRouteSnapshot
}                                 from '@angular/router';
import { Observable, of, EMPTY }  from 'rxjs';
import { mergeMap, take }         from 'rxjs/operators';
import { NeproseService } from '../services/neprose.service';

@Injectable({
  providedIn: 'root'
})
export class PropertyTypeResolverService implements Resolve<any>{

  constructor( private neproseService: NeproseService, private router: Router) { }

  resolve(): Observable<any> | Observable<never>{
    return this.neproseService.getPropertyTypes().pipe(
      take(1),
      mergeMap(propertyTypes=> {
        if (propertyTypes) {
          if(propertyTypes.propertyTypes){
            return of(propertyTypes.propertyTypes);
          }else{
            this.router.navigate(['']);
          }
        } else {
          this.router.navigate(['']);
        }
      })
    )
  }
}
